import Layout from 'layouts/Default';
import { Section } from 'elements/Containers';
import { Caption, Heading2 } from 'elements/Typography';
import Canonical from 'components/Canonical';

const Error = () => (
  <Layout>
    <Canonical />
    <Section>
      <div className="text-center md:mx-auto md:max-w-2xl">
        <Caption as="h1">Page Not Found</Caption>
        <Heading2 className="text-grey-10">
          Oops! The page you’re searching for doesn’t exist.
        </Heading2>
        <div className="mt-3 text-base text-grey-08 sm:mt-5 sm:text-xl lg:text-lg">
          <p>Or got lost in another dimension.</p>
        </div>
      </div>
    </Section>
  </Layout>
);

export default Error;
